import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createSubscriptionRequest } from "../api/subscriptionApi";

/**
 * Hook to create a new subscription request
 * Automatically invalidates subscription status on success
 */
export const useCreateSubscriptionRequest = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ planId, billingInterval }) =>
      createSubscriptionRequest(planId, billingInterval),
    onSuccess: () => {
      // Invalidate subscription status to fetch fresh data
      queryClient.invalidateQueries({ queryKey: ["subscription", "status"] });
    },
  });
};
